import ingredients from "../inventory/modules/ingredients/store";
import inventoryTurnovers from "./modules/inventoryTurnovers/store";

const store = {
  namespaced: true,

  modules: {
    ingredients,
    inventoryTurnovers,
  },
};

export default store;
